/* eslint-disable max-len */
import { FilterAndSortField as MyNetworkClientsFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/my_network/request/model/FilterAndSortField';
import {
  Client,
  MyNetworkClientsResponse,
} from '@1po/1po-bff-fe-spec/generated/my_network/response/MyNetworkClientsResponse';
import { APP_NAMESPACE } from 'app/App.constants';
import { SearchData } from 'utils';

export const R1_NETWORK_NAMESPACE = `${APP_NAMESPACE}/R1_NETWORK`;

export const GET_R1_NETWORK_REQUEST = `${R1_NETWORK_NAMESPACE}/GET_R1_NETWORK_REQUEST`;
export const SUBSCRIBE_R1_NETWORK_REQUEST = `${R1_NETWORK_NAMESPACE}/SUBSCRIBE_R1_NETWORK_REQUEST`;
export const SAVE_RETURNS_FEATURE_SETTINGS_REQUEST = `${R1_NETWORK_NAMESPACE}/SAVE_RETURNS_FEATURE_SETTINGS_REQUEST`;
export const SAVE_R1_NETWORK_REQUEST = `${R1_NETWORK_NAMESPACE}/SAVE_R1_NETWORK_REQUEST`;

export const CHANGE_R1_NOTIFY_ON_PROMOTION_REQUEST = `${R1_NETWORK_NAMESPACE}/CHANGE_R1_NOTIFY_ON_PROMOTION_REQUEST`;
export const CHANGE_R1_NOTIFY_ON_COUNTRY_PROMOTION_REQUEST = `${R1_NETWORK_NAMESPACE}/CHANGE_R1_NOTIFY_ON_COUNTRY_PROMOTION_REQUEST`;
export const CHANGE_R1_NOTIFY_ON_BANNER_REQUEST = `${R1_NETWORK_NAMESPACE}/CHANGE_R1_NOTIFY_ON_BANNER_REQUEST`;
export const CHANGE_R1_NOTIFY_ON_COUNTRY_BANNER_REQUEST = `${R1_NETWORK_NAMESPACE}/CHANGE_R1_NOTIFY_ON_COUNTRY_BANNER_REQUEST`;
export const ADD_R1_EMAIL_TO_NOTIFICATION_LIST_REQUEST = `${R1_NETWORK_NAMESPACE}/ADD_R1_EMAIL_TO_NOTIFICATION_LIST_REQUEST`;
export const REMOVE_R1_EMAIL_FROM_NOTIFICATION_LIST_REQUEST = `${R1_NETWORK_NAMESPACE}/REMOVE_R1_EMAIL_FROM_NOTIFICATION_LIST_REQUEST`;

export const GET_MY_NETWORK_CLIENTS_LIST_REQUEST = `${R1_NETWORK_NAMESPACE}/GET_MY_NETWORK_CLIENTS_LIST_REQUEST`;
export const UPDATE_MY_NETWORK_CLIENTS_CONFIG_REQUEST = `${R1_NETWORK_NAMESPACE}/UPDATE_MY_NETWORK_CLIENTS_CONFIG_REQUEST`;

export interface PromotionSettings {
  isPromotionNotificationEnabled: boolean;
  isCountryPromotionNotificationEnabled: boolean;
  isCountryBannerNotificationEnabled: boolean;
  isBannerNotificationEnabled: boolean;
  notificationsEmails: string[];
}

export interface R1NetworkState {
  returnFeatureSettings: ReturnsFeatureSettings;
  isDealerPickupEnabled: boolean;
  clientConfig: SearchData<ClientConfig>;
  promotionSettings: PromotionSettings;
  networkClients: MyNetworkClientsState;
}

export interface ReturnsFeatureSettings {
  email?: string;
  isRDReturnFeatureEnabled: boolean;
  isRDReturnFeatureEnabledByCountry: boolean;
  isMktpReturnFeatureEnabled: boolean;
  isMktpReturnFeatureEnabledByCountry: boolean;
}

export interface ClientConfig {
  isDealerPickupEnabled: boolean;
}

export interface MyNetworkClientsSort {
  field: MyNetworkClientsFilterAndSortField;
  direction: 'ASC' | 'DESC';
}

export interface MyNetworkClientsState {
  clients: SearchData<MyNetworkClientsResponse>;
  selectedClient?: Client;
  filters: Map<MyNetworkClientsFilterAndSortField, string>;
  sort: MyNetworkClientsSort;
  pagination: {
    pageSize: number;
    page: number;
  };
  isSubmitting: boolean;
}

export const MyNetworkClientsFilterField: Record<
  MyNetworkClientsFilterAndSortField,
  MyNetworkClientsFilterAndSortField
> = {
  COMPANY_NAME: 'COMPANY_NAME',
  TRESOR_CODE: 'TRESOR_CODE',
  BIR_CODE: 'BIR_CODE',
  ACTIVE: 'ACTIVE',
  CLIENT_TYPE: 'CLIENT_TYPE',
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
  BILLING_ACCOUNT: 'BILLING_ACCOUNT',
};
